import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class EventCommissionRules extends BaseAPIModel {
    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][Event][getAll] organizationId and eventId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/commission_rules`;
    }
}
